// extracted by mini-css-extract-plugin
export var articleItem = "post-module--articleItem--e0d6e";
export var catDateWrapper = "post-module--catDateWrapper--9d22d";
export var postCategories = "post-module--postCategories--90b72";
export var postDate = "post-module--post-date--4425a";
export var postExcerpt = "post-module--post-excerpt--6cfdf";
export var postImg = "post-module--post-img--fcc40";
export var postItem = "post-module--post-item--c8ee8";
export var postTitle = "post-module--post-title--7b258";
export var readTime = "post-module--read-time--b0dc9";